module.exports = __webpack_public_path__ + "img/McD_FutureConcepts_Fullscreenimages_01.eeee3a60.jpg";